var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAnexo01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,35.5c-2.4,0-4.6-0.9-6.2-2.6c-1.7-1.7-2.6-3.9-2.6-6.2c0-2.4,0.9-4.6,2.6-6.2L22,2.3c2.6-2.6,6.6-2.5,9.4,0.3 s2.9,6.8,0.3,9.4L14.6,29.1c-1.6,1.6-4.2,1.6-5.8,0c-1.6-1.6-1.6-4.2,0-5.8l11.6-11.6c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4 L10.2,24.7c-0.8,0.8-0.8,2.2,0,3c0.8,0.8,2.2,0.8,3,0l17.1-17.1C32.1,8.8,32,6,30,4S25.2,2,23.4,3.8L5.2,21.9c-1.3,1.3-2,3-2,4.8 c0,1.8,0.7,3.5,2,4.8s3,2,4.8,2c1.8,0,3.5-0.7,4.8-2L33,13.4c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L16.3,33 C14.6,34.6,12.4,35.5,10,35.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAnexo01);
export default __webpack_public_path__ + "static/media/ico-anexo-01.08cc491a27bff0430a5b8ce1c25452f9.svg";
export { ForwardRef as ReactComponent };